//所有helper 文件汇总
var user = require("./user.js")
var time = require("./time.js")
var net = require("./net.js")
var cookie = require("./cookie.js")
var text = require("./text.js")
var storage = require("./storage.js")
var observer = require("./observer.js")
var validator = require("./validator.js")
var url = require("./url.js")
var errorCode = require("./errorCode.js")
var Bridge = require("./bridge.js")
var file = require("./file.js")
var stock = require("./stock.js")

require("./shim.js")

var env = {
  isTest:false,       //69测试环境
  isRelease:false,    //生产环境
  isDevelop:false     //本机开发环境
}

var locationHref = window.location.href;
var sysFormFromData = window.data&&window.data.SysFrom?window.data.SysFrom:"";

if(locationHref.indexOf("gubawebcs.eastmoney.com")>=0 || locationHref.indexOf("gubaapitest.eastmoney.com")>=0){
  env.isTest = true;
}else if(  locationHref.indexOf("file:")>=0  ||  locationHref.indexOf("gubaapi.")>=0 || locationHref.indexOf("gubaapihttps.")>=0 ||  locationHref.indexOf("gbres.")>=0 || locationHref.indexOf("gbfek.")>=0 || sysFormFromData=="1"){
  env.isRelease = true;
}else{
  env.isDevelop = true;
}

// 判断app版本
function checkAppVersionLg (versionStr){
  if(!window.appVersion){
    return null;
  }
  // alert(window.appVersion+' '+versionStr)
  var cpVersionStr = window.appVersion;//当前APP版本
  var verArr = versionStr.split(".");//指定版本
  var cpVerArr = cpVersionStr.split(".");//当前APP版本
  if(verArr[0]*1<cpVerArr[0]*1){
    return true;
  }
  if(verArr[0]*1<=cpVerArr[0]*1 && verArr[1]*1<=cpVerArr[1]*1){
    return true;
  }
  if(verArr[0]*1<=cpVerArr[0]*1 && verArr[1]*1<=cpVerArr[1]*1 && verArr[2]*1<=cpVerArr[2]*1){
      return true;
  }
  return false;
}


var helper = {
// var helper = {}
  user : user,
  time : time,
  net : net,
  cookie: cookie,
  text: text,
  storage: storage,
  observer: observer,
  validator:validator,
  url:url,
  env:env,
  errorCode: errorCode,
  Bridge: Bridge,
  file:file,
  stock:stock,
  checkAppVersionLg: checkAppVersionLg
}

if(!window.embedHelper || typeof(window.embedHelper)=="undefined"){
  window.embedHelper = helper
}


module.exports = helper



//////////////////
// WEBPACK FOOTER
// ./src/module/helper/helper.js
// module id = 8
// module chunks = 0